import { Pipe, PipeTransform } from '@angular/core'
import { TranslateService } from '@ngx-translate/core'
import { DEFAULT_TRANSLATION_KEYS, TRANSLATION_CATEGORIES } from '@shared/constants/shared.const'
import { ExtendedString } from '@shared/utils/util.types'

@Pipe({
  name: 'translate',
  standalone: true, // Mark it as standalone
  pure: false,
})
export class TranslationPipe implements PipeTransform {
  constructor(private translate: TranslateService) {}

  transform(key: ExtendedString<DEFAULT_TRANSLATION_KEYS>, context: ExtendedString<TRANSLATION_CATEGORIES>): string {
    // added null check if key not available
    if (!key || !context) return key
    const fullKey = context ? `${context}.${key}` : key
    const translation = this.translate.instant(fullKey)
    return translation !== fullKey ? (translation?.length ? translation : key) : key
  }
}
